import styled from "styled-components";
import { colors } from "common/const/colors";
import { TextBody1, TextHeading3, TextTitle2 } from "..";
import { DefaultButton } from "../Button/new/DefaultButton";
import { Row } from "../Layout/new/constLayout";
import { CloseButton } from "../Button/new/CloseButton";
import { shortButtonStyle } from "common/const/buttonStyles";
import { I18N_KEYS } from "common/i18n/keys";
import { t } from "i18next";

const DefaultModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const DefaultModalBody = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  gap: ${({ gap }) => gap ?? "1.25rem"};

  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

const DefaultButtonField = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  /* margin-top: 2rem; */

  & > * {
    flex: 1;
  }
`;

export const DefaultModal = ({
  title,
  onClose,
  style,
  direction = "column",
  gap,
  fixedWidth,
  fixedHeight,
  leftButton,
  rightButton,
  children,
}) => (
  <DefaultModalLayout
    style={{ ...style, width: fixedWidth, height: fixedHeight }}>
    <Row style={{ justifyContent: onClose ? "space-between" : "center" }}>
      {title && <TextHeading3>{title}</TextHeading3>}
      {onClose && <CloseButton size={"1.2rem"} onClick={onClose} />}
    </Row>
    <DefaultModalBody direction={direction} gap={gap}>
      {children}
    </DefaultModalBody>

    {(leftButton || rightButton) && (
      <DefaultButtonField>
        {leftButton}
        {rightButton}
      </DefaultButtonField>
    )}
  </DefaultModalLayout>
);

export const DefaultTextModal = ({
  title,
  bodyText,
  rightButtonText,
  rightButtonOnClick,
  leftButtonText,
  leftButtonOnClick,
}) => (
  <DefaultModalLayout
    style={{
      gap: "1rem",
      minWidth: "20rem",
      minHeight: "10rem",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "pre-line",
    }}>
    <DefaultModalBody style={{ alignItems: "center" }}>
      {title && <TextTitle2>{title}</TextTitle2>}
      {bodyText && <TextBody1>{bodyText}</TextBody1>}
    </DefaultModalBody>

    <DefaultButtonField style={{ gap: "1rem" }}>
      {leftButtonText && (
        <DefaultButton
          style={shortButtonStyle}
          onClick={leftButtonOnClick}
          borderColor={colors.MainBlue}
          textColor={colors.MainBlue}>
          {leftButtonText}
        </DefaultButton>
      )}
      {rightButtonText && (
        <DefaultButton
          style={shortButtonStyle}
          onClick={rightButtonOnClick}
          fillColor={colors.MainBlue}
          textColor={colors.White}>
          {rightButtonText}
        </DefaultButton>
      )}
    </DefaultButtonField>
  </DefaultModalLayout>
);

DefaultTextModal.Confirm = ({ message, onConfirm, onCancel }) => (
  <DefaultTextModal
    bodyText={message}
    leftButtonText={t(I18N_KEYS.common.cancel)}
    leftButtonOnClick={onCancel}
    rightButtonText={t(I18N_KEYS.common.confirm)}
    rightButtonOnClick={onConfirm}
  />
);

DefaultTextModal.Message = ({ message, onOk }) => (
  <DefaultTextModal
    bodyText={message}
    rightButtonText={t(I18N_KEYS.common.confirm)}
    rightButtonOnClick={onOk}
  />
);
